/** Concatenate parameter sets, keeping repeated names; `null` when nothing is left. */
export default function mergeURLSearchParams(...parts: (URLSearchParams | null)[]): URLSearchParams | null {
    const merged = new URLSearchParams()

    parts.forEach((part) => part?.forEach((value, name) => merged.append(name, value)))

    return merged.toString() === "" ? null : merged
}
